import { CountryCode } from '../../i18n/countryCodes'
import handleResponse from './request/handlePdfResponse'
import { IEvent } from './index'

export default function(api: GlobalFetch) {
  return async function(eventId: IEvent['id'], language: CountryCode) {
    const response = await api.fetch(
      `/api/v2/reservation/pdf/id_reservation/${eventId}/lang/${language}`,
    )

    return await handleResponse(response)
  }
}
